const colors = {
    ltGreen:'#b7ce63',
    mdGray:'#353535',
    mdGreen:'#7c8a54',
    black:'#100B00',
    cardinal:'#c5283d',
    red:'#B23A48',
    white50:'rgba(255,255,255,0.5)',
    white:'#F7F7FF',
    org:'#F79256'
}

export {colors}
